var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.26944 4.29757C7.72284 3.45193 8.64036 3 9.59987 3H14.4001C15.3596 3 16.2772 3.45193 16.7306 4.29757L16.7433 4.32148C17.1961 5.17097 18.0374 5.83333 19 5.83333C20.6569 5.83333 22 7.17648 22 8.83333V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V8.83334C2 7.17648 3.34315 5.83333 5 5.83333C5.96261 5.83333 6.8039 5.17097 7.25666 4.32148L7.26944 4.29757ZM12 15.9239C13.6569 15.9239 15 14.5807 15 12.9239C15 11.267 13.6569 9.92389 12 9.92389C10.3431 9.92389 9 11.267 9 12.9239C9 14.5807 10.3431 15.9239 12 15.9239Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.3035c820f4c583161b2eb6ec364f42cc.svg";
export { ForwardRef as ReactComponent };